import { render, staticRenderFns } from "./GavelIconSvg.vue?vue&type=template&id=c937c4d6"
import script from "./GavelIconSvg.vue?vue&type=script&lang=ts"
export * from "./GavelIconSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports